import type { FastifyInstance } from "fastify";

export const findUserByEmail = async (app: FastifyInstance, email: string) => {
  const user = await app.prisma.user.findFirst({
    where: { email },
  });
  return user;
};

export const findUserById = async (app: FastifyInstance, id: string) => {
  const user = await app.prisma.user.findFirst({
    where: { id },
  });
  return user;
};

export const createUser = async (
  app: FastifyInstance,
  data: {
    firstName: string;
    lastName: string;
    email: string;
    password: string;
  },
) => {
  const user = await app.prisma.user.create({
    data,
  });
  return user;
};

export const verifyRefreshToken = async (
  app: FastifyInstance,
  token: string,
) => {
  const payload = app.jwt.verify<{
    type: "refresh" | "access";
    userId: string;
    role: string;
  }>(token);

  if (payload.type !== "refresh") {
    throw new Error("Invalid token type");
  }

  return payload;
};
